import api from './client';

export async function fetchAnnouncements(authConfig, params = {}) {
  const { data } = await api.get('/api/announcements', {
    params,
    ...(authConfig || {})
  });
  return Array.isArray(data) ? data : [];
}

export async function createAnnouncement(payload, authConfig) {
  const { data } = await api.post('/api/announcements', payload, authConfig);
  return data;
}

export async function updateAnnouncement(id, payload, authConfig) {
  const { data } = await api.put(`/api/announcements/${id}`, payload, authConfig);
  return data;
}

export async function deleteAnnouncement(id, authConfig) {
  await api.delete(`/api/announcements/${id}`, authConfig);
}

export async function fetchCurrentAnnouncements(params = {}) {
  const { data } = await api.get('/api/announcements/current', { params });
  return data || { todayEvents: [], upcoming: null };
}
